module.exports = __webpack_public_path__ + "img/RedMissile-B02-1-250.a1c3e062.jpg";